/**
 * Localized label for a time-tracking status code (Saudi Arabic via i18n).
 */
export function getTimeTrackingCodeLabel(code, fallbackLabel, t) {
  if (!code) return fallbackLabel || '';
  const key = `modules.pointage.timeTrackingCodes.${code}`;
  const translated = t(key, { defaultValue: '' });
  if (translated) return translated;
  return fallbackLabel || String(code);
}

/**
 * Display form: "P — Present full day"
 */
export function formatTimeTrackingCodeOption(code, fallbackLabel, t) {
  const label = getTimeTrackingCodeLabel(code, fallbackLabel, t);
  return `${code} - ${label}`;
}
